<section class="h-full flex justify-between items-center gap-8">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      class="grow"
    >
      {{ labelText }}
    </blaze-element-label>
  }
  <span>
    @switch (type) {
      @case ('counter') {
        <span>
          <button class="counter" (click)="emitClick()">
            {{ (count$ | async) ?? '\u2026' }}
          </button>
        </span>
      }
      @case ('icon_with_counter') {
        <span>
          <button class="icon" (click)="emitClick()">
            <mat-icon [svgIcon]="notificationIcon" />
            <span class="count" [class.invisible]="(count$ | async) === '0'">
              {{ (count$ | async) ?? '\u2026' }}
            </span>
          </button>
        </span>
      }
    }
  </span>
</section>
